module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-28-941e0e35c642500b73d5272a8884aabb.png";